"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = exports.Image = void 0;
var _mui = require("@ori-ui/mui");
var _constants = require("./constants");
const Image = exports.Image = (0, _mui.styled)('img')({
  height: _constants.PRODUCT_IMAGE_SIZE,
  width: _constants.PRODUCT_IMAGE_SIZE,
  minWidth: _constants.PRODUCT_IMAGE_SIZE
});
const Root = exports.Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  background: theme.palette.grey[100],
  borderRadius: theme.shape.borderRadius,
  height: _constants.PRODUCT_IMAGE_WRAPPER_HEIGHT,
  width: _constants.PRODUCT_IMAGE_SIZE,
  padding: theme.spacing(3, 0),
  boxSizing: 'border-box'
}));
